import React from "react";
import autoBind from 'react-autobind';
import { Layout, Form, Row, Col, Select, Button, message } from 'antd';
import PageHeader from '@/components/PageHeader/PageHeader';
import DatePicker from '@/components/DatePicker/DatePicker';
import { GrDocumentPdf, GrDocumentExcel } from "react-icons/gr";
import moment from 'moment';
//
import CustomComponent from '@/components/CustomComponent';
import WhiteBox from '@/views/commonComponents/WhiteBox';
import CommonLoadingView from '@/views/commonComponents/CommonLoadingView';
//
import config from "@/config/config";
import Utils from "@/components/Utils";
import Globals from '@/config/Globals';
//
export default class AdminEmploymentByClassificationReportView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { isLoading: false };
  }

  //Live cycle
  componentDidMount() { document.title = `${config.ApplicationName} - Employment by Classification`; }

  //Actions
  async handleSubmit() {
    const formData = await this.form.validateFields();

    if (formData) {
      const date = formData.date ? moment(formData.date).format(Globals.DefaultAPIDateFormat) : null;
      this._generate({ date });
    }
  }

  //UI
  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader title="Employment by Classification" extra={[<Button key="1" onClick={this.handleSubmit} type='primary'>Generate Report</Button>]} />
        <Layout.Content>
          <WhiteBox>
            <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
              <Row>
                <Col span={4}>
                  <Form.Item name="date" label="Cutoff Date" rules={[{ required: true, message: 'This field is required!' }]}>
                    <DatePicker format={Globals.DefaultSimpleDateFormat} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    )
  }

  /* private API */
  async _generate(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.reports.employmentByClassification(data);
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      Utils.downloadBlob(resp.body, `Employment by Classification - ${moment(new Date()).format('MMYY')}`, 'pdf');
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
    this.setState({ isLoading: false });
  }
}
